"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StorageWithExpiration {
    constructor(storage) {
        this.storage = null;
        //default value 2 hours in milliseconds
        this.defaultExpirationTime = 7200000;
        this.expirationKeyPrefix = '__expired_storage__';
        this.storage = storage;
    }
    setDataToStorage(key, value, expirationTime = this.defaultExpirationTime) {
        this.storage.setItem(key, value);
        this.setExpirationData(key, expirationTime);
    }
    getDataFromStorage(key) {
        if (this.isTimeExpired(key)) {
            this.removeDataFromStorage(key);
            return;
        }
        return this.storage.getItem(key);
    }
    setExpirationData(key, expirationTime) {
        const expirationMoment = new Date();
        this.storage.setItem(this.expirationKeyPrefix + key, expirationMoment.setSeconds(expirationMoment.getSeconds() + expirationTime).toString());
    }
    isTimeExpired(key) {
        const expiredTime = this.storage.getItem(this.expirationKeyPrefix + key);
        if (expiredTime) {
            const expiredTimeInMs = parseInt(expiredTime, 10);
            return Date.now() > expiredTimeInMs;
        }
    }
    removeDataFromStorage(key) {
        this.storage.removeItem(key);
        this.storage.removeItem(this.expirationKeyPrefix + key);
    }
}
exports.default = StorageWithExpiration;
